<template>
  <div class="help-container">
    <div class="pdf-header">
      <h2 class="pln-color">Manual</h2>
      <div class="btn-group">
        <button class="download-btn" @click="downloadPdf">
          <span>Download PDF</span>
        </button>
        <button class="download-btn" @click="openPdfInNewTab">
          <span>Open PDF</span>
        </button>
      </div>
    </div>
    <iframe
      class="manual-iframe"
      src="/manualwebisee.pdf"
      width="100%"
      :height="iframeHeight"
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      containerHeight: window.innerHeight,
    };
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },

  computed: {
    iframeHeight() {
      return this.windowHeight - 120;
    },
  },

  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },

    downloadPdf() {
      const link = document.createElement("a");
      link.href = "/manualwebisee.pdf";
      link.download = "manualwebisee.pdf";
      link.click();
    },

    openPdfInNewTab() {
      window.open("/manualwebisee.pdf", "_blank");
    },
  },
};
</script>

<style scoped>
.help-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
}

.pdf-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  /* background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0; */
  flex-shrink: 0;
}

.pdf-header h2 {
  margin: 0;
  font-size: 1.5rem;
  color: #333;
}

.download-btn {
  padding: 8px 16px;
  background-color: #009FB7;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.95rem;
  transition: background-color 0.3s ease;
}

.download-btn:hover {
  background-color: #0056b3;
}

.download-btn:active {
  background-color: #004085;
}

.manual-iframe {
  border: none;
  flex: 1;
  width: 100%;
}

.btn-group {
  display: flex;
  gap: 10px;
}
</style>
